export default {
	getOne: async (mvcmydashboard, params) => {
		const id = params.id;

		let item = {id};

		if (!mvcmydashboard) return {data: item};

		let sessionuuid = await mvcmydashboard.getCurrentSession();
		let user = await mvcmydashboard.getSessionUser(sessionuuid).catch(err => {});

		if (!user) return {data: item}

		item = {id: user.uuid, uuid: user.uuid, useruuid: user.uuid,
					email: user.email, useremail: user.email, 
					name: user.name, username: user.name}

		return {data: item}
	},
};